"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPaletteConfig = void 0;
exports.ColorPaletteConfig = {
    mode: 'light',
    background: {
        default: '#FAFAFA',
    },
    black: {
        100: '#0B1638',
        200: '#232E4C',
        400: '#6C7388',
        500: '#CED0D7',
        600: '#F3F3F5',
        main: '#3C4560',
        light: '#CED0D7',
        dark: '#232E4C',
    },
    primary: {
        100: '#0B1638',
        200: '#284496',
        400: '#688EFC',
        500: '#ACC2FF',
        600: '#F0F4FF',
        main: '#4467C9',
        light: '#ACC2FF',
        dark: '#284496',
    },
    secondary: {
        100: '#08313A',
        200: '#278EA5',
        400: '#6BE4FF',
        500: '#AEF0FF',
        600: '#F0FCFF',
        main: '#47BED8',
        light: '#AEF0FF',
        dark: '#278EA5',
    },
    tertiary: {
        100: '#004236',
        200: '#04A284',
        400: '#66FFE2',
        500: '#A7FFEE',
        600: '#E9FFFB',
        main: '#21E6C1',
        light: '#A7FFEE',
        dark: '#04A284',
    },
    reds: {
        100: '#630B0B',
        200: '#A72222',
        400: '#FF5959',
        500: '#FFA4A4',
        600: '#FFEEEE',
        main: '#EB4747',
        light: '#FFA4A4',
        dark: '#A72222',
    },
    yellows: {
        100: '#63550B',
        200: '#A79123',
        400: '#FFE45A',
        500: '#FFF04A',
        600: '#FFFCEE',
        main: '#EBD047',
        light: '#FFF04A',
        dark: '#A79123',
    },
    text: {
        primary: '#3C4560',
        secondary: '#0B1638',
    },
    error: {
        100: '#630B0B',
        200: '#A72222',
        400: '#FF5959',
        500: '#FFA4A4',
        600: '#FFEEEE',
        main: '#EB4747',
        light: '#FFA4A4',
        dark: '#A72222',
    },
    warning: {
        100: '#63550B',
        200: '#A79123',
        400: '#FFE45A',
        500: '#FFF04A',
        600: '#FFFCEE',
        main: '#EBD047',
        light: '#FFF04A',
        dark: '#A79123',
    },
    info: {
        100: '#08313A',
        200: '#278EA5',
        400: '#6BE4FF',
        500: '#AEF0FF',
        600: '#F0FCFF',
        main: '#47BED8',
        light: '#AEF0FF',
        dark: '#278EA5',
    },
    success: {
        100: '#004236',
        200: '#04A284',
        400: '#66FFE2',
        500: '#A7FFEE',
        600: '#E9FFFB',
        main: '#21E6C1',
        light: '#A7FFEE',
        dark: '#04A284',
    },
    divider: '#CED0D7',
    offWhite: '#FAFAFA',
};
//# sourceMappingURL=data:application/json;base64,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